<div class="stripe-card-data">
    <div *ngIf="access == 'summary' || access == 'invoice-manage'" class="row col-12 col-lg-12 col-xl-12 col-md-12 col-sm-12">
        <div *ngFor="let card of cardList; index as i" class="col-4 col-lg-4 col-xl-4 col-md-6 col-sm-12">
            <div class="card-list">
                <div class="card-head">
                    <div class="d-inline-block ch-col ch-left">Credit Card
                        <div *ngIf="card.id == primaryCard" class="d-inline-block cursor card-primary">
                            <i class="pi pi-star"></i><span>Primary</span>
                        </div>
                        <div *ngIf="card.id != primaryCard" class="d-inline-block cursor card-primary set-primary" (click)="setupCardAction('primary', card.id)">
                            <i class="pi pi-check"></i><span title="Set Primary">Set Primary</span>
                        </div>
                    </div>            
                    <div class="d-inline-block ch-col ch-right text-right">
                        <div *ngIf="card.id != primaryCard" class="d-inline-block cursor card-action edit">
                            <i class="pi pi-pencil"></i><span title="Edit">Edit</span>
                        </div>
                        <div *ngIf="card.id != primaryCard || card.id == primaryCard" class="d-inline-block cursor card-action delete" (click)="setupCardAction('delete', card.id)">
                            <i class="pi pi-trash"></i><span title="Delete">Delete</span>
                        </div>
                    </div>
                </div>
                <div class="card-info" style="overflow: hidden;text-overflow: ellipsis;">
                    <!--p *ngIf="access == 'summary'">{{card.id}}</p-->
                    <p style="overflow: hidden;text-overflow: ellipsis;">{{customerList?.name}}</p>
                    <b>xxxx-xxxx-xxxx-{{card?.card?.last4}}</b>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="access != 'summary' &&  access != 'invoice-manage'" class="card-info view-card {{access}}" [ngClass]="{'card-position': access == 'manage'}">
        <span *ngIf="cardList.length == 0" class="card-text no-card"><i class="pi pi-times" [ngClass]="{'no-card-pi': access == 'invoice-manage'}"></i>No credit card on file</span>
        <span *ngIf="cardList.length > 0" class="card-text"><i class="pi pi-check"></i>Credit card on file</span>
    </div>
    <div *ngIf="cardAction && email || ((access == 'manage' && cardList.length == 0) || (access == 'invoice-manage' && cardList.length == 0))" class="card-info new-card {{access}}" [ngClass]="{'card-position': access == 'manage'}">
        <button pbutton="" pripple="" type="button" icon="pi pi-plus" label="New Card" class="ap-button-outlined p-button-rounded card-btn p-button p-component">
            <span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span>
            <span class="p-button-label" (click)="createNewCard()">New Card</span>
        </button>
    </div>
</div>

<p-dialog styleClass="cart-clear-popup delete-card-popup" *ngIf="actionPopup" [(visible)]="actionPopup" [style]="{width: '30vw'}"
  [modal]="true" [showHeader]="false">
  <div class="clear-cart-popup">
    <div class="warning">
      Are you sure you'd like to {{actionType == 'delete' ? 'delete this card' : 'set this card as primary'}}?
    </div>
    <div class="pt-2">
      <button class="btn" style="background-color: #469073;color:white;margin-right:10px;padding: 5px 35px;"
        (click)="submitAction(actionType)">Yes</button>
      <button class="btn" style="background-color: #2f3967;color:white;padding: 5px 35px;"
        (click)="actionPopup = false">No</button>
    </div>
  </div>
</p-dialog>
